export default __webpack_public_path__ + "static/media/neural-net-logo.bd7fc147.svg";